import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { formatToMexicoDateTime } from "../../../components/utils/format";
import StatusLabel from "../../../components/utils/StatusLabel";
import { TableWithdrawalModal } from "../tabletModalWithdrawal";

interface WithdrawInfoModalProps {
  open: boolean;
  onClose: () => void;
  data?: any;
}

export const WithdrawInfoModal: React.FC<WithdrawInfoModalProps> = ({ open, onClose, data }) => {
  if (!data) return null;



  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      <DialogTitle>Información del retiro</DialogTitle>
      <DialogContent dividers>
        <p><strong>ID:</strong> {data._id}</p>
        <p><strong>Email:</strong> {data.email}</p>
        <p><strong>Folio:</strong> {data.folio}</p>
        <p><strong>Id STP:</strong> {data.stp_id}</p>
        <p><strong>Liquidación:</strong> {data.tsLiquidacion}</p>
        <p>
          <strong>Monto:</strong>{" "}
          {data?.amount !== undefined && data?.amount !== null
            ? `$${Number(data.amount).toFixed(2)}`
            : "No disponible"}
        </p>
        <p><strong>Estatus:</strong> <StatusLabel value={data?.status} withStyle={false} /></p>
        <p>
          <strong>Fecha de solicitud:</strong>{" "}
          {formatToMexicoDateTime(data.created_at)}
        </p>
      </DialogContent>
      <DialogContent>
        <TableWithdrawalModal data={data} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};